<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/productBom',title:'资源池预借'},{title:'预借审批'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                        <h1>预借主体</h1>
                    </div>
                    <div class="pieceCon n-bu">
                        <div class="h-pieceCon2">
                            <el-form :model="f" label-position="right" ref="f" :inline="true"
                                     class="demo-ruleForm h-formbLine h-formbLine1">
                                <div class="h-rowCon Bianji">
                                    <div class="h-rowCon1 Bianji">
                                        <el-form-item label="预借单号" disable class="h-elformWrap-2" prop="advanceCode">
                                            <el-input disabled v-model="f.advanceCode"></el-input>
                                        </el-form-item>
                                        <el-form-item label="领域" class="h-elformWrap-2">
                                            <brselect
                                                    category="swyl_field_new"
                                                    :v="f.field"
                                                    v-model="f.field"
                                                    disabled
                                                    clearable
                                                    placeholder="--请选择--">
                                            </brselect>
                                        </el-form-item>
                                        <el-form-item prop="channelCode" label="渠道" class="h-elformWrap-2">
                                            <brselect
                                                    :multiple="true"
                                                    :disabled="true"
                                                    :readonly="true"
                                                    category="sales_region" :v="f.channelCode"
                                                    v-model="f.channelCode"></brselect>
                                        </el-form-item>
                                        <el-form-item label="申请金额" class="h-elformWrap-2" prop="totalMoney">
                                            <el-input disabled v-model="f.totalMoney"></el-input>
                                        </el-form-item>
                                        <el-form-item label="补足资源池亏损金额" class="h-elformWrap-2" prop="totalMoney">
                                            <el-input disabled v-model="f.supplyMoney"></el-input>
                                        </el-form-item>
                                        <el-form-item label="附件" style="width: 33%;">
                                            <brupload
                                                    v-model="f.fileUrl"
                                                    :refid=f.id
                                                    reftype="YJ_FIEL"
                                                    :limit="1"
                                                    :showtime="false">
                                            </brupload>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="n-hu ljjtablepaddings9" v-if="!this.showDetail">
                    <div class="h-pieceTitle2">
                        <h1>预借明细</h1>
                    </div>
                    <div class="yxtable" style="padding-left: 0.15rem;">
                        <el-table
                                ref="multipleTable"
                                :data="tableData"
                                style="width: 100%"
                                :border="true"
                                max-height="440"
                        >
                            <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                            </el-table-column>
                            <el-table-column
                                    prop="projectName"
                                    label="项目名称"
                                    width="220"
                                    :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="specialCode"
                                    label="特价版本号"
                                    width="220"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="channelCode"
                                    label="渠道"
                                    :show-overflow-tooltip="true"
                                    width="250">
                                <template slot-scope="scope">
                                    <dictname category="sales_region"  :v="scope.row.channelCode"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="220"
                                    prop="projectMoney"
                                    :show-overflow-tooltip="true"
                                    label="项目金额">
                            </el-table-column>
                            <el-table-column
                                    prop="advanceMoney"
                                    label="预借金额"
                                    :show-overflow-tooltip="true"
                                    width="220">
                            </el-table-column>
                            <el-table-column
                                    prop="advancePlan"
                                    label="项目必要性及关差方案"
                                    :show-overflow-tooltip="true"
                                    width="250">
                            </el-table-column>

                        </el-table>

                    </div>
                </div>

            </div>
            <div class="h-table h-mrt30 h-rowBox" style="margin-top:0.8rem">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:20px">预借审批</h1>
                    <el-form :model="yjshenpi" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 w-elformWrap-3" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                            <el-input v-model="yjshenpi.shenheyijian" placeholder="请输入"
                                      :disabled="taskstatus==1" ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-row style="display: flex;justify-content: center;margin: 30px 0;">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
            <el-button class="h-btn h-bBtn h-bgred" @click="tongguobohui(1)" v-if="taskstatus==0">驳回</el-button>
            <el-button class="h-btn h-bBtn h-bggreen" @click="tongguobohui(2)"  v-if="taskstatus==0">通过</el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    export default {
        data() {
            return {
                f:{
                    id:null,
                    advanceCode: null,
                    totalMoney: null,
                    supplyMoney: null,
                    channelCode: null,
                    fileUrl:null,
                    detailList:[],
                    channelCoode:null,
                },
                tableData:[],
                yjshenpi:{
                    shenheyijian:'',
                },
                taskstatus:'',
                showhistory:false,
                instid:'',
                //物料id
                ywid:'',
                //taskid
                taskid:'',
                showDetail:false,
            }
        },
        created() {
            //业务id
            this.ywid = this.$router.history.current.query.ywid;

            //taskid
            this.taskid = this.$router.history.current.query.taskid;

            //instid
            this.instid = this.$router.history.current.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            this.query();
        },
        methods: {
            viewpress(){
                this.showhistory = true;
            },
            query(){
                var data = {}
                data.id = this.ywid;
                ss.resourcePool.getAdvanceDetail(data).then(rd=>{
                    if(rd.f){
                        this.f = rd.msg;
                        this.tableData = this.f.detailList;
                        if(this.f.supplyMoney != null && this.f.supplyMoney != 0 && this.f.detailList[0].advanceMoney == 0){
                            this.showDetail = true;
                        }
                    }
                })
            },
            tongguobohui(q){
                var shenPiEntity = {
                    yewuzhujian: this.ywid,//业务主键
                    taskid: this.taskid,//页面拿到的taskid
                    msg: this.yjshenpi.shenheyijian,//  页面填写的审核意见
                    jiediantiaojianming:'tongguoorbohui',//通过还是驳回的节点条件名字
                    instid:this.instid,//选择要进入的审批版本id
                }
                // 通过还是驳回的flag  1驳回  2通过
                if(q==1){
                    shenPiEntity.tongguoorbohui=1;
                    shenPiEntity.optflag = '驳回';
                    if (!this.yjshenpi.shenheyijian) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }

                }else if(q==2){

                    shenPiEntity.tongguoorbohui=2;
                    shenPiEntity.optflag = '通过';
                }


                ss.resourcePool.shpAdvance(shenPiEntity).then(rd => {
                    if(rd.f==true){

                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    }
                })
            },
            //取消按钮
            quxiaoanniu(){

                this.$router.go(-1);

            },
        }
    }
</script>

<style scoped>

</style>